module.exports = __webpack_public_path__ + "static/img/caoxi.a35c4e3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mingpian/caoxi.png
// module id = DdWj
// module chunks = 0